<template>
	<div>
<!--		<el-row>-->
<!--			<el-col>-->
<!--				<el-form :inline='true'>-->
					<!--          <el-form-item label="省份:">-->
					<!--            <el-select v-model="filters.provinceCode" filterable clearable>-->
					<!--              <el-option v-for="item in provinceSearchOptions" :key="item.id" :label="item.name"-->
					<!--                         :value="item.code"></el-option>-->
					<!--            </el-select>-->
					<!--          </el-form-item>-->
<!--					<el-form-item label="项目完成时间:">-->
<!--						<el-date-picker @change="changePicker" v-model="pickerData" type="daterange" range-separator="至"-->
<!--						                start-placeholder="开始日期" value-format="yyyy-MM-dd HH:mm:ss" end-placeholder="结束日期">-->
<!--						</el-date-picker>-->
<!--					</el-form-item>-->
<!--					<el-form-item>-->
<!--						<toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>-->
<!--					</el-form-item>-->
<!--				</el-form>-->
<!--			</el-col>-->
<!--		</el-row>-->
		<!-- 列表 -->
		<el-table id="exportTab" :data="tableData" border style="width: 100%" v-loading="listLoading"
		          ref="multipleTable" :highlight-current-row='true' >
			<el-table-column type='index' label="序号" width='60' align="center"></el-table-column>
			<el-table-column prop="userName" align="center" width="120" label="问题ID（合计数量）">
				<template slot="header" slot-scope="scope" >
					{{'问题ID'}}<br>（{{tableData.length}}）
				</template>
				<template slot-scope="scope">
					<div style="text-align: center;">
						<!--显示提示文字 el-tooltip-->
						<!--            <el-tooltip :content="scope.row.userName" placement="left">-->
						<el-button type="text" @click="getProject(scope.row)">
							{{scope.row.questionId}}
						</el-button>
						<!--            </el-tooltip>-->
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="questionDescription" label="问题描述" align="center" width=""></el-table-column>
			<el-table-column prop="standard" label="规范条文" align="center" width="220"></el-table-column>
			<el-table-column prop="itemType" label="事项标签" align="center" width="120">
				<template slot-scope="scope">
					<el-tag v-if="scope.row.itemType === '重要事项'"  type="primary">{{'重要事项'}}</el-tag>
					<el-tag v-if="scope.row.itemType === '其他事项'"  type="danger">{{'其他事项'}}</el-tag>
					<el-tag v-if="scope.row.itemType === '无'"  type="warning">{{'无'}}</el-tag>
				</template>
			</el-table-column>
			<el-table-column prop="isMiddleAi" label="是否139" align="center" width="120">
				<template slot="header" slot-scope="scope" >
					{{'是否139'}}<br>（{{total.isMiddleAi}}）
				</template>
				<template slot-scope="scope">
					<el-tag v-if="scope.row.isMiddleAi === '是'"  type="primary">{{'是'}}</el-tag>
					<el-tag v-if="scope.row.isMiddleAi === '否'"  type="danger">{{'否'}}</el-tag>
				</template>
			</el-table-column>
			<el-table-column prop="isDevelopmentAi" label="AI已研发" align="center" width="120">
				<template slot="header" slot-scope="scope" >
					{{'AI已研发'}}<br>（{{total.isDevelopmentAi}}）
				</template>
				<template slot-scope="scope">
					<el-tag v-if="scope.row.isDevelopmentAi === '是'"  type="primary">{{'是'}}</el-tag>
					<el-tag v-if="scope.row.isDevelopmentAi === '否'"  type="danger">{{'否'}}</el-tag>
				</template>
			</el-table-column>
			<el-table-column prop="isDetectAi" label="AI可检出" align="center" width="120">
				<template slot="header" slot-scope="scope" >
					{{'AI可检出'}}<br>（{{total.isDetectAi}}）
				</template>
				<template slot-scope="scope">
					<el-tag v-if="scope.row.isDetectAi === '是'"  type="primary">{{'是'}}</el-tag>
					<el-tag v-if="scope.row.isDetectAi === '否'"  type="danger">{{'否'}}</el-tag>
				</template>
			</el-table-column>
			<el-table-column prop="humanReportNum" label="研发上线后人工采纳数" align="center" width="120">
				<template slot="header" slot-scope="scope" >
					{{'研发上线后人工采纳数'}}<br>（{{total.humanReportNum}}）
				</template>
			</el-table-column>
			<el-table-column prop="aiTotalNum" label="研发上线后AI提交数" align="center" width="120">
				<template slot="header" slot-scope="scope" >
					{{'研发上线后AI提交数'}}<br>（{{total.aiTotalNum}}）
				</template>
			</el-table-column>
			<el-table-column prop="aiReportNum" label="研发上线后AI采纳数" align="center" width="120">
				<template slot="header" slot-scope="scope" >
					{{'研发上线后AI采纳数'}}<br>（{{total.aiReportNum}}）
				</template>
			</el-table-column>
			
		</el-table>
		
		<!--		<el-dialog :title="`${projectTableData[0]?projectTableData[0].userName:''}-绩效明细`" :visible.sync="dialog.project.show" v-model="dialog.project.show"-->
		<el-dialog :title="`明细`" :visible.sync="dialog.project.show" v-model="dialog.project.show"
		           :close-on-click-modal="false" width='96%' >
			<el-table id="exportTab" :data="detailTableList" border style="width: 100%" v-loading="listLoading"
			          ref="multipleTable" :highlight-current-row='true' >
				<el-table-column type='index' label="序号" width='50' align="center"></el-table-column>
				
				<el-table-column prop="projectName" label="项目名称" align="center" width=""></el-table-column>
				<el-table-column prop="confirmProblem" label="意见明细" align="center" width=""></el-table-column>
				<el-table-column prop="drStandardItemDescribe" label="规范条文" align="center" width=""></el-table-column>
				<el-table-column prop="isMiddleAi" label="是否139" align="center" width="80">
						<template slot-scope="scope">
							<el-tag v-if="scope.row.standardIsMiddleAi === true"  type="primary">{{'是'}}</el-tag>
							<el-tag v-if="scope.row.standardIsMiddleAi === false"  type="danger">{{'否'}}</el-tag>
						</template>
				</el-table-column>
				<el-table-column prop="standardIsSmallAi" label="是否53" align="center" width="80">
					<template slot-scope="scope">
						<el-tag v-if="scope.row.standardIsSmallAi === true"  type="primary">{{'是'}}</el-tag>
						<el-tag v-if="scope.row.standardIsSmallAi === false"  type="danger">{{'否'}}</el-tag>
					</template>
				</el-table-column>
<!--				<el-table-column prop="createTime" label="提交时间" align="center" width="120"></el-table-column>-->
				<el-table-column prop="isReport" label="是否采纳" align="center" width="64">
					<template slot-scope="scope">
						<el-tag v-if="scope.row.isReport === true"  type="primary">{{'是'}}</el-tag>
						<el-tag v-if="scope.row.isReport === false"  type="danger">{{'否'}}</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="userIsAi" label="提交者" align="center" width="80">
					<template slot-scope="scope">
						<el-tag v-if="scope.row.userIsAi === 1"  type="primary">{{'AI'}}</el-tag>
						<el-tag v-if="scope.row.userIsAi === 0"  type="danger">{{'人工'}}</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="createTime" label="提交时间" align="center" width="120"></el-table-column>
<!--				<el-table-column prop="nodeCreateTime" label="创建时间" align="center" width="120"></el-table-column>-->
				<el-table-column prop="itemType" label="事项标签" align="center" width="120">
					<template slot-scope="scope">
						<el-tag v-if="scope.row.itemType === 1"  type="primary">{{'重要事项'}}</el-tag>
						<el-tag v-if="scope.row.itemType === 9"  type="danger">{{'其他事项'}}</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="isDevelopmentAi" label="AI已研发范围" align="center" width="80">
					<template slot-scope="scope">
						<el-tag v-if="scope.row.isDevelopmentAi === 0"  type="danger">{{'不研发'}}</el-tag>
						<el-tag v-else-if="scope.row.isDevelopmentAi === 1"  type="primary">{{'已研发'}}</el-tag>
						<el-tag v-else-if="scope.row.isDevelopmentAi === 2"  type="warning">{{'待研发'}}</el-tag>
						<el-tag v-else type="info">{{'-'}}</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="standardIsSmallAi" label="AI可检出" align="center" width="70">
					<template slot-scope="scope">
						<el-tag v-if="scope.row.isDetectAi === true"  type="primary">{{'是'}}</el-tag>
						<el-tag v-if="scope.row.isDetectAi === false"  type="danger">{{'否'}}</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="fileList" label="问题截图" width="60" align="center" show-overflow-tooltip>
					<template slot-scope="scope">
						<el-button @click="onPreviewProblem(scope.row)" type="text" size="small">查看</el-button>
					</template>
				</el-table-column>
			
			</el-table>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="dialog.project.show = false">关闭</el-button>
			</div>
		</el-dialog>
		<el-dialog :visible.sync="previewFalse" title="截图查看" width="50%"  @close="previewFalse=false">
			<template  >
				<div class="file-list-wrapper">
					<div v-for="(url,index) in fileList" >
						{{index+1+'、'+url.split(',')[0]}}
						<el-image  :key="url" :src="url.split(',')[1]" lazy></el-image>
					</div>
				</div>
			</template>
		</el-dialog>
	</div>
</template>

<script>
import util from '../../../util/date'
import Toolbar from '../../components/Toolbar'
import { getButtonList } from '@/promissionRouter'
import {
	getUserRefuseProjectList,
	getUserProjectDetailList,
	getAreaDictionaryList,
	getStatisticsProjectDetailReportData,
	getTaskDetailList,
	getUserStatisticList,
	getStatisticsKYJCProjectList,
	getStatisticsKYJCProjectDetail,
	getStatisticsKYJCAiProgressList, getStatisticsKYJCAiProgressDetail,
} from '@/api/api'
import Vue from 'vue'
import FileSaver from 'file-saver'
import * as XLSX from 'xlsx'

export default {
	components: { Toolbar },
	data () {
		return {
			total:{},
			totalDetail:{},
			detailTableList: [],
			tableDataList:[],
			overdueDataTableDataReview:[],
			overDue:[],
			// projectList:[],
			// projectType31Array:[],
			// projectType188Array:[],
			userOpinionDetailList: [],
			utils: '',
			buttonList: [],
			needData: '',
			filters: {
				name: '',
				assignedUserId: undefined,
				bizStartDate: undefined,
				bizEndDate: undefined,
				orderSort: undefined,
				provinceCode: undefined,
				expertType: undefined
			},
			tableData: [],
			projectTableData: [],
			projectTableData1: [],
			refuseTableData: [],
			refuseTableData1: [],
			datatoExport: [],
			datatoExport1: [],
			datatoExport2: [],
			datatoExport3: [],
			overdueDataTableData: [],
			listLoading: false,
			dialog: {
				refuse: {
					show: false
				},
				project: {
					show: false
				},
				overdueData: {
					show: false
				},
			},
			dialog1: {
				refuse: {
					show: false
				},
				project: {
					show: false
				},
				overdueData: {
					show: false
				},
			},
			pickerData: [],
			expertOptions: [{
				'id': 62,
				'namespace': 'CommonService.OrgPermission.ExpertIdentity',
				'key': 0,
				'value': '驻场图审工程师',
				'sort': 1,
				'remark': ''
			}, {
				'id': 63,
				'namespace': 'CommonService.OrgPermission.ExpertIdentity',
				'key': 1,
				'value': '在线图审专家',
				'sort': 2,
				'remark': ''
			}, {
				'id': 162,
				'namespace': 'CommonService.OrgPermission.ExpertIdentity',
				'key': 5,
				'value': '技术部专家',
				'sort': 6,
				'remark': ''
			}],//专家类型
			provinceSearchOptions: [],
			isExecuting: false,
			refuseId: '',
			projectId: '',
			tabledataDetailDialog:false,
			detailDataList:[],
			detailDataListReport:[],
			fileList:[],
			previewFalse:false,
		}
	},
	created () {
		this.utils = util
		let routers = window.localStorage.router
				? JSON.parse(window.localStorage.router)
				: []
		this.buttonList = getButtonList(this.$route.path, routers)
		this.getDataList()
		this.init()
	},
	methods: {
		
		onPreviewProblem(value){
			this.fileList = value.fileList
			this.previewFalse=true
		},
		//点击姓名详情的某一行
		dataListDetail(val,item){
			this.detailDataList = []
			// console.log(val,'详情')
			let params = {
				projectId:val.projectId
			}
			getStatisticsKYJCAiProgressDetail(params).then(res=>{
				if (res.data.success){
					// console.log(res.data.response,'detail22222222')
					this.detailDataListReport = res.data.response
					
				}
			})
		},
		//详情明细总数
		tabledataDetail(val,item){
			this.dataListDetail(val,item)
			this.tabledataDetailDialog = true
			
		},
		
		
		
		
		formatUserName (userName) {
			return userName.replace(/,/g, '<br><br>');
		},
		formatUserNames (userName) {
			return userName.replace(/,/g, '<br>');
		},
		callFunction (item) {
			this[item.func].apply(this, item)
		},
		
		init () {
			// 获取省份
			getAreaDictionaryList({ parentId: 1 }).then(res => {
				this.provinceSearchOptions = res.data.response.reverse()
			})
		},
		// 查询
		getListData () {
			this.getDataList()
		},
		// 列表查询接口
		getDataList () {
			let params = {
			
			}
			getStatisticsKYJCAiProgressList(params).then(res => {
				const result = res.data;
				if (result.success) {
					this.tableData = result.response;
					// 初始化累加结果对象（初始值为0）
					const totalObj = {
						humanReportNum: 0,
						aiTotalNum: 0,
						aiReportNum: 0,
						isMiddleAi: 0,
						isDevelopmentAi: 0,
						isDetectAi: 0,
					};
					
					// 遍历数组，累加目标属性
					this.tableData.forEach(item => {
						// 处理属性可能不存在或为undefined的情况（默认取0）
						totalObj.humanReportNum += (item.humanReportNum || 0);
						totalObj.aiTotalNum += (item.aiTotalNum || 0);
						totalObj.aiReportNum += (item.aiReportNum || 0);
						item.isMiddleAi === '是'?totalObj.isMiddleAi++:'';
						item.isDevelopmentAi === '是'?totalObj.isDevelopmentAi++:'';
						item.isDetectAi === '是'?totalObj.isDetectAi++:'';
					});
					
					// 此时totalObj即为累加后的新对象，可根据需要存储（例如赋值给this.total）
					this.total = totalObj;
					
				}
				
			});
			
		},
		handleSelect (item) {
			this.filters.assignedUserId = item.id
		},
		querySearchAsync (queryString, cb) {
			
			let userList = this.tableData.map(user => user.userName);
			
		},
		createStateFilter (queryString) {
			return (state) => {
				return (state.userName.indexOf(queryString) === 0)
			}
		},
		// 封装执行数组循环的方法
		async dialogDemo () {
			let row = this.mianTbaleList
			
			for (const item of row) {
				// 执行循环中的操作，这里可以是异步操作
				// console.log(item,'item')
				await this.getRefuse1(item, item.id);
				await this.getProject1(item, item.id);
			}
			
		},
		async processItems () {
			const flattenedArray = this.refuseTableData1.reduce((accumulator, currentArray) => {
				return accumulator.concat(currentArray);
			}, []);
			const flattenedArray1 = this.projectTableData1.reduce((accumulator, currentArray) => {
				return accumulator.concat(currentArray);
			}, []);
			if (this.projectTableData1.length >= this.mianTbaleList.length && this.refuseTableData1.length >= this.mianTbaleList.length) {
				// this.datatoExport = [...flattenedArray1, ...flattenedArray]
				// console.log(this.projectTableData1, 'data1')
				for (const item of this.mianTbaleList) {
					const customIndex = item.id;
					// const targetProjectObjects = this.projectTableData1.forEach(item=>{item.filter(obj => customIndex===obj.customIndex)});
					const targetRefuseObjects = this.refuseTableData1.forEach(item => {item.filter(obj => customIndex === obj.customIndex)});
					
					// 遍历数组并将对象按ID分组
					// this.datatoExport.forEach((obj) => {
					//   const customIndex = item.id ;
					//   const idToObjectMap = [];
					//   if (idToObjectMap[customIndex]) {
					//     idToObjectMap[customIndex].push(obj);
					//   } else {
					//     idToObjectMap[customIndex] = [obj];
					//   }
					//   console.log(idToObjectMap,'cccc')
					// });
					
				}
				// console.log(this.datatoExport,'xxx')
				// 创建一个对象，用于存储具有相同ID的对象
				// const idToObjectMap = [];
				
				// 遍历数组并将对象按ID分组
				// this.datatoExport.forEach((obj) => {
				//   const customIndex = ;
				//   if (idToObjectMap[customIndex]) {
				//     idToObjectMap[customIndex].push(obj);
				//   } else {
				//     idToObjectMap[customIndex] = [obj];
				//   }
				// });
				// // 输出具有相同ID的小对象
				// for (const customIndex in idToObjectMap) {
				//   if (idToObjectMap[customIndex].length > 1) {
				//     console.log(`具有相同ID ${customIndex} 的小对象：`);
				//     idToObjectMap[customIndex].forEach((item) => {
				//       console.log(`   ${item.name}`);
				//     });
				//   }
				// }
				// console.log(idToObjectMap,'vvvv')
				// const flattenedArray = this.refuseTableData1.reduce((accumulator, currentArray) => {
				//   return accumulator.concat(currentArray);
				// }, []);
				// const flattenedArray1 = this.projectTableData1.reduce((accumulator, currentArray) => {
				//   return accumulator.concat(currentArray);
				// }, []);
				//   for (const item of this.mianTbaleList) {
				//     const arrayId1= item.id
				//     // console.log(this.projectTableData1,'[')
				//     console.log(this.projectTableData1,3333)
				//     const targetProjectObjects = this.projectTableData1.forEach(item => {item.filter(obj => arrayId1.includes(obj.customIndex))});
				//     const targetRefuseObjects = this.refuseTableData1.forEach(item=>{item.filter(obj => arrayId1.includes(obj.customIndex))});
				//
				//     // console.log(targetProjectObjects,'re')
				//     this.datatoExport = [...targetProjectObjects, ...targetRefuseObjects];
				//     if (this.datatoExport1.length < this.mianTbaleList.length) {
				//       this.datatoExport1.push(this.datatoExport);
				//     }
				//   }
			}
			// console.log(this.datatoExport1,'datatoExport1')
		},
		async exportListData () {
			let wb = XLSX.utils.book_new();
			// 导出主表格
			let mainTable = document.querySelector('#exportTab');
			let xlsxParam = { raw: true };
			let mainSheet = XLSX.utils.table_to_sheet(mainTable, xlsxParam);
			XLSX.utils.book_append_sheet(wb, mainSheet, '绩效考核');
			// 从多个子表格中导出数据
			for (let item of this.tableData) {
				this.tableDataList.projectList = [];
				// 显示当前子表格的对话框
				this.getProject(item)
				// 等待对话框完全渲染（您可能需要实现这一部分）
				await this.$nextTick();
				let oneTable = document.querySelector('#personal');
				let oneSheet = XLSX.utils.table_to_sheet(oneTable, xlsxParam);
				// 在Excel工作表中使用唯一名称来标识每个子表格
				XLSX.utils.book_append_sheet(wb, oneSheet, `子表-${item.userName}`);
				// 关闭当前子表格的对话框
				this.dialog.project.show = false;
			}
			// 将工作簿导出为Excel文件
			let wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' });
			try {
				FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), '绩效考核.xlsx');
			} catch (e) {
				if (typeof console !== 'undefined') {
					console.log(e, wbout);
				}
			}
			return wbout;
		},
		getRefuse (row) {
			getUserRefuseProjectList({ taskIds: row.refuseProjectTaskIds }).then(res => {
				if (res.data.success) {
					this.refuseTableData = res.data.response
					this.dialog.refuse.show = true
				}
			})
		},
		
		async getRefuse1 (row, index) {
			getUserRefuseProjectList({ taskIds: row.refuseProjectTaskIds }).then(res => {
				// if (res.data.success) {
				let array1 = res.data.response
				let customIndex = index; // 设置自定义下标的初始值
				if (this.refuseTableData1.length < this.mianTbaleList.length) {
					// 使用map函数为array1添加自定义下标值
					array1 = array1.map(item => {
						const customIndexValue = `${customIndex}`;
						return { ...item, customIndex: customIndexValue };
					});
					this.refuseTableData1.push(array1)
				}
			})
			
			// console.log(this.refuseTableData1)
		},
		async getProject1 (row, index) {
			getUserProjectDetailList({ taskIds: row.auditProjectTaskIds }).then(res => {
				let array2 = res.data.response
				let customIndex = index; // 设置自定义下标的初始值
				if (this.projectTableData1.length < this.mianTbaleList.length) {
					array2 = array2.map(item => {
						const customIndexValue = `${customIndex}`;
						return { ...item, customIndex: customIndexValue };
					});
					this.projectTableData1.push(array2)
				}
				
			})
		},
		getOverdueDataDialog(){
			this.dialog.overdueData.show=false
			this.overDue = undefined
			this.overdueDataTableData = undefined
		},
		getOverdueData (row) {
			// console.log(row,'row')
			this.overDue = undefined
			this.overdueDataTableData = undefined
			getTaskDetailList({ taskIds: row.overdueDateTaskIds }).then(res => {
				if (res.data.success) {
					this.overDue = res.data.response
					// console.log(this.overDue,'over')
					if (this.overDue){
						const aaa = this.overDue.filter(item => item.projectType !==188)
						console.log(aaa,'aaa')
						this.overdueDataTableData = aaa
						// console.log(this.overdueDataTableData,' this.overdueDataTableData ')
						this.dialog.overdueData.show = true
					}else {
						this.dialog.overdueData.show = true
					}
				}
			})
		},
		getOverDueReview(){
			if (this.overDue){
				const aaa = this.overDue.filter(item => item.projectType === 188)
				this.overdueDataTableDataReview = aaa.filter(item => item.completeDate >= item.overdueDate)
				this.dialog1.overdueData.show = true
			}else {
				this.dialog1.overdueData.show = true
			}
			
		},
		getProject (row) {
			this.tableDataList = row
			this.getDetailTableList(row)
			
			
		},
		getDetailTableList (row) {
			let params = {
				// userId : row.userId,
				// endData: this.filters.bizEndDate,
				// startData: this.filters.bizStartDate,
				questionId: row.questionId
			}
			getStatisticsKYJCAiProgressDetail(params).then(res => {
				if (res.data.success) {
					this.detailTableList = res.data.response
					this.dialog.project.show = true
				}
			})
		},
		// 日期选择
		changePicker (data) {
			if (data !== null) {
				this.filters.bizStartDate = data[0]
				this.filters.bizEndDate = data[1]
			} else {
				this.filters.bizStartDate = undefined
				this.filters.bizEndDate = undefined
			}
		},
		// 时间格式化
		formatCreateTime: function (row, column) {
			return !row.NoticeTime || row.NoticeTime == ''
					? ''
					: util.formatDate.format(new Date(row.NoticeTime), 'yyyy-MM-dd hh:mm')
		},
	}
}
</script>

<style lang="stylus" scoped>
.custom-div {
	margin-bottom: 15px; /* Adds 15px margin outside the div */
	font-size : 16px
}

.grey-background {
	background-color: #f2f2f2; /* 使用你喜欢的颜色代码 */
}

.el-table .warning-row {
	background: oldlace;
}

.el-table .success-row {
	background: #f0f9eb;
}
</style>
